import type { Finding } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/findings/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const findingDetailsSection: FormItem<Finding> = {
  cssClass: 'tmm-section-no-background',
  caption: 'Finding Details',
  colCount: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
  },
  items: [allFields.tenantId, allFields.assetId],
};

const statusDetailsSection: FormItem<Finding> = {
  cssClass: 'tmm-section',
  caption: 'Status Details',
  colCount: {
    xs: 1,
    sm: 1,
    md: 3,
    lg: 3,
  },
  items: [allFields.status, allFields.priority, allFields.workOrderId],
};

const reportedDetailsSection: FormItem<Finding> = {
  cssClass: 'tmm-section',
  caption: 'Reported Details',
  colCount: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
  },
  items: [
    allFields.cause,
    allFields.symptom,
    allFields.reportedOn,
    allFields.reportedById,
    { ...allFields.description, colSpan: 2 },
  ],
};

const costSection: FormItem<Finding> = {
  cssClass: 'tmm-section',
  caption: 'Cost',
  colCount: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
  },
  items: [allFields.cost, allFields.dueDate],
};

export const createFields: FormItem<Finding>[] = [
  findingDetailsSection,
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: {
      xs: 1,
      sm: 1,
      md: 3,
      lg: 3,
    },
    items: [
      { ...allFields.shortDescription, colSpan: 2 },
      { ...allFields.type, colSpan: 1 },
    ],
  },
  statusDetailsSection,
  reportedDetailsSection,
  costSection,
];

export const updateFields: FormItem<Finding>[] = [
  findingDetailsSection,
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 2,
    },
    items: [{ ...allFields.shortDescription, colSpan: 2 }, allFields.type, allFields.displayNumber],
  },
  statusDetailsSection,
  reportedDetailsSection,
  costSection,
  getHistorySection(),
];
